<div class="p500-ui-modal__body-title">
  <div class="title">Rules for Currencies</div>
  <div class="actions">
    <div class="action">
      <button p500-ui-button-icon size="small" color="primary" type="button" (click)="addCondition()">
        <p500-ui-icon name="plus-circle"></p500-ui-icon>
      </button>
    </div>
  </div>
</div>

<div class="c-conditions c-conditions--d">
  <div class="c-conditions__groups-conditions c-form c-form--d">
    <gtd-payments-system-condition
      *ngFor="let parsedControl of conditionsParsed.controls; let i = index"
      [index]="i"
      [formControl]="parsedControl"
      [name]="'pqlScheme'"
      [conditions]="conditions"
      [getValueComponentByType]="presetHelpers.getValueComponentByType"
      [getSignsData]="presetHelpers.getSignsDataPql"
      (remove)="removeCondition($event)"
      class="c-conditions__condition c-form__section"
    >
    </gtd-payments-system-condition>
  </div>
</div>
